import { Home } from "../../../routes";
import style from "./DesktopHeader.module.scss";
import cx from "classnames";
import { Anchor } from "../Anchor";
import { useWindowSize } from "../../../utils";
import { ColorContext } from "../../../ColorContext";
import { useContext, useEffect, useRef, useState } from "react";
import React from "react";
import {
  About,
  AnchorContext,
  ProperCare,
  ToBuy,
  Videos,
} from "../../../AnchorContext";

// const useWindowEvent = (callback: () => void, dependencies: any[]) => {
//   useEffect
// }

const checkScrollSpeed = (() => {
  let lastPos: number | null = null;
  let newPos: number;
  let timer: number;
  let delta: number;
  const delay = 50;

  function clear() {
    lastPos = null;
    delta = 0;
  }

  clear();

  return function () {
    newPos = window.scrollY;
    if (lastPos != null) {
      // && newPos < maxScroll
      delta = newPos - lastPos;
    }
    lastPos = newPos;
    clearTimeout(timer);
    //@ts-ignore
    timer = setTimeout(clear, delay);
    return delta;
  };
})();

const useScroll = () => {
  const [isSticky, setIsSticky] = useState(false);
  const [showOnScroll, setShow] = useState(false);
  useEffect(() => {
    let timeout: NodeJS.Timeout | null = null;
    const onscroll = () => {
      const scrollTop = window.scrollY;
      if (scrollTop >= 90) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
      const scrollSpeed = checkScrollSpeed();
      if (Math.abs(scrollSpeed) > 5) {
        setShow(true);
        if (timeout) {
          clearTimeout(timeout);
        }
        timeout = setTimeout(() => {
          setShow(false);
        }, 1000);
      }
    };

    window.addEventListener("scroll", onscroll);

    return () => {
      window.removeEventListener("scroll", onscroll);
    };
  }, []);

  return { isSticky, showOnScroll };
};

export const DesktopHeader = () => {
  const { width } = useWindowSize();
  const { color } = useContext(ColorContext);
  const { anchor } = useContext(AnchorContext);

  const [mouseInside, setMouseInside] = useState(false);
  const isFirstScreen = anchor === "About";
  const ref = useRef<NodeJS.Timeout | null>(null);
  const { isSticky, showOnScroll } = useScroll();

  return (
    <>
      {isSticky && <header className={style.spacer} />}
      {isSticky && (
        <header
          className={cx(style.spacer, style.sticky)}
          onMouseEnter={() => {
            setMouseInside(true);
          }}
        />
      )}

      <header
        className={cx(style.header, {
          [style["sticky-hidden"]]: isSticky,
          [style.show]:
            ((showOnScroll && !isFirstScreen) || mouseInside) && isSticky,
        })}
        style={{ backgroundColor: !isSticky ? "white" : color }}
        onMouseEnter={() => {
          isSticky && setMouseInside(true);
          if (ref.current) {
            clearTimeout(ref.current);
          }
        }}
        onMouseLeave={() => {
          ref.current = setTimeout(() => {
            setMouseInside(false);
          }, 1000);
        }}
      >
        <div
          className={cx(
            style.header__nav,
            { [style.jcSb]: isSticky },
            "wrapper"
          )}
        >
          {isSticky && width && width > 1110 && (
            <div className={style.logo}>
              <Home.Link>
                <img src="/images/logo1.svg" alt="logo" />
              </Home.Link>
            </div>
          )}

          <nav>
            <ul>
              <About.Link>
                <li>О проекте</li>
              </About.Link>
              <ProperCare.Link>
                <li>Правильный уход</li>
              </ProperCare.Link>

              <Videos.Link thisPage>
                <li>Видео</li>
              </Videos.Link>
              {/* <ToBuy.Link>
                <li>Средства ухода</li>
              </ToBuy.Link> */}
            </ul>
          </nav>
        </div>
      </header>
      <div className={style["logo-container"]}>
        <div className="wrapper">
          <div className={style["logo-big"]}>
            <img src="/logo-main.svg" alt="logo" />
          </div>
        </div>
      </div>
    </>
  );
};
